import Matrix, { EnvironmentEnum } from '@mc/matrix-main'
import Url from '@mc/mc-utils/js/url/url'
import { domain } from '@/defines/environment/config'
import { isHarmony } from '@/defines/environment/getters/get_harmony'

const matrix = new Matrix()

// APP下载页相关配置
const APP_DOWNLOAD_URL = {
  mall_ios:
    'https://itunes.apple.com/cn/app/mei-cai-shang-cheng/id1067740478?mt=8',
  mall_harmony:
    'https://appgallery.huawei.com/app/detail?id=com.meicai.MeicaiStoreP',
  mall_android: 'QwmssE',
  yyb_mall_android: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.meicai.mall'
}

let browserMarkDom

/**
 * @param {boolean} isOnlyOpen 页面没有url参数情况下，只唤起App，不跳转任何页面
 * @param {boolean} showWxBrowerPopup 微信或支付宝环境下，是否展示浏览器打开提示弹层
 * @param {function} openToast 自定义弹窗提示信息
 * */

export const openApp = ({
  isOnlyOpen = false,
  showWxBrowerPopup = true,
  openToast,
  route // 自定义route
}) => {
  const { isMallApp, isMiniProgram, isAndroid, isIOS, environment } = matrix
  if (isMallApp || isMiniProgram) return

  if (environment === EnvironmentEnum.Wechat && showWxBrowerPopup) {
    openBrowerMark()
    return
  }

  openToast?.()

  // 安卓/IOS都用Schema方式
  if (isAndroid) {
    openAndroidApp(handleAppSchema(isOnlyOpen, route))
  } else if (isIOS) {
    // 由于Universal Link需要跨域情况下才能触发，必需app和online两个域名同时支持当前的h5页面，为了防止未下载APP情况下跳转出现404，所以ios也采用Schema方式
    window.location.href = handleAppSchema(isOnlyOpen, route)
  }
}

const handleAppSchema = (isOnlyOpen, route) => {
  const appSchema = 'meicaistore://mall'
  const search = window.location.search
  const urlIndex = search.indexOf('?url=')

  // 1、所有页面有 url 参数
  if (urlIndex !== -1) {
    return `${appSchema}?url=${search.substr(urlIndex + 5)}`
  }

  // 2、下载页只唤起 APP
  if (isOnlyOpen) {
    return appSchema
  }

  if (route) {
    if (typeof route === 'string') {
      route = { path: route }
    }
    const { path, query = {} } = route
    const queriesString = new Url('').stringifyQueryObj(query)

    return `${appSchema}?url=${window.encodeURIComponent(
      `${path}?${queriesString}`
    )}`
  }

  // 3、cms 二级页打开本身
  return `${appSchema}?url=${encodeURIComponent(window.location.href)}`
}

// 提示用户浏览器打开
const openBrowerMark = () => {
  if (browserMarkDom) {
    browserMarkDom.style.display = 'block'
    return
  }
  browserMarkDom = document.createElement('div')
  browserMarkDom.style.cssText =
    'width:100vw;height:100vh;position:fixed;z-index:999;left:0;top:0;background-color:rgba(0,0,0,.5);color:#fff'
  browserMarkDom.innerHTML = `<div style="position: absolute;top:0.3rem;right:0.32rem;width: 3.56rem;height: 0.72rem; background-color: rgba(0,0,0,0.8);border-radius: 2px;font-size: 0.28rem;line-height: 0.72rem;text-align: center;color: #fff;">
                                <div style=" position: absolute;top: -0.3rem;right: 0.15rem; width: 0;height: 0;border: 0.16rem solid transparent; border-bottom-color: rgba(0,0,0,0.8);"></div>
                                点击后选择在浏览器打开
                              </div>`
  document.body.appendChild(browserMarkDom)
  browserMarkDom.addEventListener('click', function () {
    browserMarkDom.style.display = 'none'
  })
}

// 安卓采用iframe方式
const openAndroidApp = schemaUrl => {
  const ifr = document.createElement('iframe')
  setTimeout(() => {
    if (ifr) {
      document.body.removeChild(ifr)
    }
  }, 6 * 1000)

  ifr.setAttribute('src', schemaUrl)
  ifr.setAttribute('style', 'display:none')
  document.body.appendChild(ifr)
}

// 下载APP
export const downLoadApp = () => {
  const { isMallApp, isMiniProgram, isAndroid, isIOS, environment } = matrix

  if (isMallApp || isMiniProgram) return
  if (isHarmony()) {
    location.href = APP_DOWNLOAD_URL.mall_harmony
  } else if (isIOS) {
    location.href = APP_DOWNLOAD_URL.mall_ios
  } else if (isAndroid) {
    // 打开应用宝
    if (environment === EnvironmentEnum.Wechat) {
      location.href = APP_DOWNLOAD_URL.yyb_mall_android
    } else {
      $jsonp.send(
        `https://ampstore.${domain}/ampstore/app/downjsonp?mark=${APP_DOWNLOAD_URL.mall_android}&build_env=production&callback=appDownloadCallBack`,
        {
          callbackName: 'appDownloadCallBack',
          onSuccess: function (response) {
            if (response.ret === 1) {
              location.href = response.data.url
            } else {
              const errorMsg = response.msg
                ? '下载错误:' + response.msg
                : '下载错误'
              alert(errorMsg)
            }
          },
          onTimeout: function (err) {
            alert('下载错误' + err)
          }
        }
      )
    }
  }
}

const $jsonp = (() => {
  var that = {}
  that.send = (src, options) => {
    const callbackName = options.callbackName || 'callback'
    const onSuccess = options.onSuccess || function () {}
    const onTimeout = options.onTimeout || function () {}
    const timeout = options.timeout || 10
    const timeoutTrigger = setTimeout(() => {
      window[callbackName] = () => {}
      onTimeout()
    }, timeout * 1000)
    window[callbackName] = data => {
      clearTimeout(timeoutTrigger)
      onSuccess(data)
    }
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = src
    document.getElementsByTagName('head')[0].appendChild(script)
  }
  return that
})()
